import { MeetingRoomRequestInput } from "@lib/store";
import { useMeetingRoomRequestContext } from "@lib/logic";
import { useHereAndNow } from "../HereAndNowContext";

type MeetingRoomRequestTimeOverrides = Pick<MeetingRoomRequestInput, "startDateTime" | "endDateTime">;

type MeetingRoomRequestOverrides =
  | (Partial<MeetingRoomRequestTimeOverrides> & {
      buildingId?: never;
      selectedFloorId?: never;
    })
  | (Partial<MeetingRoomRequestTimeOverrides> & {
      buildingId: string;
      selectedFloorId: string;
    });

export const useActiveMeetingRoomRequest = (overrides: MeetingRoomRequestOverrides = {}) => {
  const { buildingId, selectedFloorId, currentRoomDateTimes } = useHereAndNow();

  return useMeetingRoomRequestContext({
    buildingId: overrides.buildingId ?? buildingId,
    selectedFloorId: overrides.selectedFloorId === undefined ? selectedFloorId : overrides.selectedFloorId,
    startDateTime: overrides.startDateTime ?? currentRoomDateTimes.startDateTime,
    endDateTime: overrides.endDateTime ?? currentRoomDateTimes.endDateTime,
  });
};
